import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
 

export default function SEO() {

  const location = useLocation();

  const canonicalUrl = `${process.env.REACT_MAIN_URL}${location.pathname}`;

  return (
    <Helmet>
      <link 
        rel="canonical" 
        href={canonicalUrl}
      />
    </Helmet>
  );
}